import { LiveAnnouncer } from '@angular/cdk/a11y';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { ReturnOrderClass } from 'src/app/models/return-container';
import { ContainersList } from 'src/app/models/return-container-reference';
import { ReleaseOrderService } from 'src/app/services/release-order.service';

@Component({
  selector: 'logzy-containerslistforpickup',
  templateUrl: './containerslistforpickup.component.html',
  styleUrls: ['./containerslistforpickup.component.scss']
})
export class ContainerslistforpickupComponent implements OnInit, OnChanges {

  errorObj: any = {};
  loading: boolean = true;
  isShow: boolean = false;
  isShown: boolean = false;
  isDisabled: boolean = false;
  isCustomer: boolean = false;
  isHide: boolean = true;
  canvas: string = "Canvas";
  open1: string = "sidepanel";
  bindName = new BehaviorSubject(null);
  error: boolean = false;

  @Input() containers;
  @Input() type: string = '';
  @Input() errorList: [] = [];
  @Input() request_id: string = '';
  @Input() containerSizeTypeId: string = '';

  returnConObject: ReturnOrderClass;
  validContainers: ContainersList[] = [];
  selection = new SelectionModel<ContainersList>(true, []);
  selectedContainer = [];
  tempContainers: ContainersList[] = [];

  @ViewChild('title') title: any;
  @ViewChild('input') input: ElementRef;
  @Input() update: boolean = false;
  @Output() updateChange = new EventEmitter<boolean>();
  dropped: boolean = false;
  screenHeight: number;
  screenWidth: number;
  shadowX!: number;
  shadowY!: number;
  containerIds;
  container_numbers: string;

  onMouseMove(e: any) {
    this.dropped = true;
    if (e.clientX < (this.screenWidth / 2)) {//right shadow
      this.shadowX = 5;
    } else if (e.clientX > (this.screenWidth / 2)) {//left shadow
      this.shadowX = -5;
    }
    if (e.clientY > (this.screenHeight / 2)) {//top shadow
      this.shadowY = -4;
      this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
    } else if (e.clientY < (this.screenHeight / 2)) {//bottom shadow
      this.shadowY = 4;
      this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
    }
  }

  displayColumns = ['select', 'container_number', 'container_size_type', 'ownership'];

  constructor(private _liveAnnouncer: LiveAnnouncer, private releaseservice: ReleaseOrderService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.selection.clear();
    this.getPickedUpContainers(this.request_id, this.containerSizeTypeId);
  }

  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
  }

  announceSortChange(sortState: Sort) {
    console.log(sortState);
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  // isAllSelected() {
  //   const numSelected = this.selection.selected.length;
  //   const numRows = this.containers?.data?.length;
  //   return numSelected === numRows;
  // }
  isAllSelected(): boolean {
    const eligibleRows = this.containers?.data.filter(
      (row: any) => row.latest_new_container_lifecycle.status.dev_code === 'in_use'
    );
    return this.selection.selected.length === eligibleRows.length;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  // masterToggle() {
  //   this.isAllSelected() ?
  //     this.selection.clear() :
  //     this.containers?.data.forEach(row => this.selection.select(row));
  // }
  masterToggle(): void {
    const eligibleRows = this.containers?.data.filter(
      (row: any) => row.latest_new_container_lifecycle.status.dev_code === 'in_use'
    );
    this.isAllSelected()
      ? this.selection.clear()
      : eligibleRows.forEach((row: any) => this.selection.select(row));
  }

  // logSelection() {
  //   this.selection.selected.forEach(s => console.log(s.container_number));
  // }

  filterContainers(containerNumbers: string = '') {
    console.log('containerNumbers', containerNumbers);
    // this.selection.clear();
    const delimiterRegex = /[ ,\n]+/;
    if (containerNumbers != null && containerNumbers != '') {
      this.tempContainers = [];
      // const resultArray = containerNumbers.split(this.delimiterRegex);
      // console.log(resultArray);
      this.validContainers.map(container => {
        if (containerNumbers.includes(container.container_number)) {
          if (!this.tempContainers.includes(container))
            this.tempContainers.push(container);
        }
      });
      console.log('this.tempContainers', this.tempContainers);
      if (this.tempContainers.length != 0)
        this.containers.data = this.tempContainers;
      else
        this.containers.data = [];
    } else {
      this.tempContainers = [];
      this.containers ? this.containers.data = this.validContainers : [];
    }
  }

  getPickedUpContainers(request_id: string, containerSizeTypeId: string) {
    this.loading = true;
    this.releaseservice.getPickedUpContainers(request_id, containerSizeTypeId, this.type).subscribe(res => {
      console.log('this.containers', res);
      this.containers = new MatTableDataSource(res);
      this.validContainers = this.containers.data;
      this.loading = false;
    })
  }
}
